import React from 'react';

interface INicheBeautySvgProps {
  width?: number;
  height?: number;
}

export const NicheBeautySvg: React.FC<INicheBeautySvgProps> = ({
  width = 40,
  height = 40,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="13"
        cy="14"
        r="3"
        stroke="#4CAF50"
        strokeWidth="1.5"
        fill="none"
      />
      <circle
        cx="27"
        cy="14"
        r="3"
        stroke="#4CAF50"
        strokeWidth="1.5"
        fill="none"
      />
      <path
        d="M14 16L30 26"
        stroke="#4CAF50"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M26 16L10 26"
        stroke="#4CAF50"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};
